import { render, staticRenderFns } from "./uploadFilesDrag.vue?vue&type=template&id=7d9f24f4&scoped=true"
import script from "./uploadFilesDrag.vue?vue&type=script&lang=js"
export * from "./uploadFilesDrag.vue?vue&type=script&lang=js"
import style0 from "./uploadFilesDrag.vue?vue&type=style&index=0&id=7d9f24f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9f24f4",
  null
  
)

export default component.exports